<script lang="ts">
	export let progress: number
  export let disabled: boolean

  $: angle = (360 * progress) as number
  
	$: background = `
    radial-gradient(white 50%, transparent 51%),
    conic-gradient(transparent 0deg ${angle}deg, ${disabled ? '#BDBFC4' : '#D6DCFF'} ${angle}deg 360deg),
    ${disabled ? '#BDBFC4' : '#66C383'};
  ` as string
</script>

<div class="progress-circle" style="{`--background: ${background}`}" />

<style>
  .progress-circle {
    background: var(--background);
    border-radius: 50%;
    width: 24px;
    height: 24px;
  }
</style>